function handleSideSearchBarClick() {  
    window.sidebarClose();
    setTimeout(() => {
    const searchBar = document.querySelector('.search-mobile');
    if( !searchBar ) return;
    searchBar.click();
    window.scrollTo({
        top: 0,
        behavior: "smooth" // Optional: makes scrolling smooth
      });
    }, 100);
}

// on document load
document.addEventListener('DOMContentLoaded', () => {
   const sideSearchBar = document.querySelector('.side-search-bar');
   sideSearchBar.addEventListener('click', handleSideSearchBarClick)
});